import React from 'react'
import Terms from '../../Componet/Terms'
import NewsletterL1 from '../../Componet/Newsletter/NewsletterL1'
import HerosectionHeader from '../../Componet/Herosection/HerosectionHeader'
import Cons1 from '../../Componet/Consulting/Cons1'


function TermsConditions() {
    return (
        <>
            <HerosectionHeader folder1={"pages"} folder2={"Utilities"} name={"Consulting Services"} />
            <div class="page-content">
                <Cons1></Cons1>
                <NewsletterL1 />
            </div>
        </>
    )
}

export default TermsConditions
